<div class="overlay" [class.show]="show"></div>
<div class="spanner" [class.show]="show">
    <div class="loader"></div>
    <p>{{message}}</p>
</div>